import * as React from "react";
import { AppContext, INavigationProps } from "navigation/App";
import { handleToggleDropdown } from "shared/styles/helpers";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { ThemeType } from "shared/styles/theme";
import { NavigationItemChevron } from "./NavigationItemChevron";
import DropdownButton from "shared/components/DropdownButton";
import { IAppReducerState } from "navigation/shared/model";
import { CustomToggleButton } from "shared/components/CustomToggle";
import { NavLink } from "navigation/styled";

export const UserItems: React.FC<INavigationProps> = (props) => {
    const { appState, dispatch } = React.useContext<IAppReducerState>(AppContext);

    const handleShowCookiePolicyBanner = () => {
        dispatch({ type: "SET_SHOW_COOKIE_POLICY_BANNER", showCookiePolicyBanner: true })
    }

    if (props.isAuthenticated) {
        return (
            <li>
                <DropdownButton
                    id="user-dropdown"
                    buttonComponent={(
                        <NavLink
                            className="dropbtn"
                            title={props.username}
                            onClick={() => handleToggleDropdown("user-dropdown")}
                        >
                            {props.username}&nbsp;
                            <NavigationItemChevron />
                        </NavLink>
                    )}
                    dropDownButtonCustomStyles={{ position: 'initial' }}
                    dropDownContentCustomStyles={{ marginTop: '16px' }}
                >
                    <a href="Dashboard">Dashboard</a>
                    <UserSettings />
                    <NavLink href={"Account/SignOut"}>
                        {FRENDS.Localizations.SignOut}
                    </NavLink>

                    <br />
                    <a href="ProductTours">Product Tours</a>
                    {appState.feedbackUrl !== null && appState.feedbackUrl !== "" && <a href={appState.feedbackUrl} rel="noreferrer" target={"_blank"}>Give feedback</a>}
                    {appState.hasAppInsightsKey && <button onClick={handleShowCookiePolicyBanner}>Cookie policy</button>}
                    <a>Version: {appState.coreVersion}</a>
                </DropdownButton>
            </li>
        );
    } else {
        return (
            <li>
                <NavLink href={"Account/SignIn"}>
                    {FRENDS.Localizations.SignIn}
                </NavLink>
            </li>
        );
    }
}

const UserSettings: React.FC = () => {

    const [themeType, setCurrentTheme] = useUserTheme();

    const handleChangeTheme = () => setCurrentTheme({ theme: themeType === ThemeType.light ? ThemeType.dark : ThemeType.light });

    return (
        <CustomToggleButton onClick={handleChangeTheme} checked={themeType === ThemeType.dark}>
            Dark mode &nbsp;
        </CustomToggleButton>
    )
}